import { getObstacleType } from '@/utils/enumHelper.js';
let setting_ins = null;
export let vehicleScale = {
    width: 0.025,
    length: 0.015,
    height: 0.015
}
export function getelementSetting() {
    if (setting_ins) {
        return setting_ins;
    }
    let setting = {
        mapSetting: {
            stop_line: {
                visible: true,
                group: null,
                mapObject: null
            },
            boundary: {
                visible: true,
                group: null,
                mapObject: null
            },
            lane: {
                visible: true,
                group: null,
                mapObject: null
            },
            lane_virtual: {
                visible: false,
                group: null,
                mapObject: null
            },
            lane_road_mocked: {
                visible: false,
                group: null,
                mapObject: null
            },
            // 面元素统一下沉到线元素下方。
            // 这样即使相机是斜视角，区域底色也不会压住 lane / boundary / stop_line。
            clear_zone: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            cross_walk: {
                visible: false,
                group: null,
                mapObject: null,
                z: -0.01
            },
            free_area: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            gate: {
                visible: true,
                group: null,
                mapObject: null
            },
            intersection: {
                visible: true,
                group: null,
                mapObject: null
            },
            parking: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            pillar: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            prohibited_area: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            speed_bump: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            safety_island: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            multiLayerArea: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.02
            },
            traffic_light: {
                visible: true,
                group: null,
                mapObject: null
            }
        },
        mapSetting_topic: {
            local_navi_line: {
                visible: true,
                group: null,
                mapObject: null,
            },
            entry_line: {
                visible: true,
                group: null,
                mapObject: null,
            },
            road_mark: {
                visible: true,
                group: null,
                mapObject: null
            },
            stop_line: {
                visible: true,
                group: null,
                mapObject: null
            },
            boundary: {
                visible: true,
                group: null,
                mapObject: null
            },
            lane: {
                visible: true,
                group: null,
                mapObject: null
            },
            // topic 模式与普通模式保持同一层级规则，避免不同页面表现不一致。
            clear_zone: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            cross_walk: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            free_area: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            gate: {
                visible: true,
                group: null,
                mapObject: null
            },
            intersection: {
                visible: true,
                group: null,
                mapObject: null
            },
            parking: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            pillar: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            prohibited_area: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            speed_bump: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            safety_island: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.01
            },
            multiLayerArea: {
                visible: true,
                group: null,
                mapObject: null,
                z: -0.02
            },
            traffic_light: {
                visible: true,
                group: null,
                mapObject: null
            }
        },
        obstacle: {}
    }
    let obstacle_type = getObstacleType();
    obstacle_type.forEach(element => {
        setting.obstacle[element.eName] = {
            visible: true,
            group: null,
            mapObject: null
        }
    });
    setting_ins = setting
    return setting
}

export let ObstacleSetting = (() => {
    let setting = {}
    let obstacle_type = getObstacleType();
    obstacle_type.forEach(element => {
        setting['obstacle_' + element.key] = element.viewSetting
    });
    return setting
})();
